import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formatea un importe para mostrarlo con separador de miles (punto), sin
 * decimales y con el símbolo del euro. Los valores llegan del backend (Innova)
 * como cadena con coma decimal y sin separador de miles (p.ej. "6000,00",
 * "300000") -> se muestran como "6.000 €", "300.000 €".
 *
 * Si el valor no es numérico se devuelve intacto (sin €).
 *
 * @author Inetum
 */
@Pipe({
    name: 'amountNoDecimals'
})
export class AmountNoDecimalsPipe implements PipeTransform {

    transform(value: any): string {
        if (value === null || value === undefined) {
            return value;
        }
        const raw = value.toString().trim();
        if (raw === '') {
            return raw;
        }
        // Deja solo dígitos y separadores; si no queda ningún dígito es texto -> intacto.
        const cleaned = raw.replace(/[^\d,.-]/g, '');
        if (!/\d/.test(cleaned)) {
            return raw;
        }
        // Coma = separador decimal; el punto (si lo hubiera) sería de miles.
        const normalized = cleaned.replace(/\./g, '').replace(',', '.');
        const num = parseFloat(normalized);
        if (isNaN(num)) {
            return raw;
        }
        const rounded = Math.round(num);
        const sign = rounded < 0 ? '-' : '';
        const abs = Math.abs(rounded).toString();
        return sign + abs.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }

}
